import { generateClassName } from '@klv/shared/utils/functions';
import Buttons from '@klv/molecules/buttons';

import * as s from './styles/footerCta.module.scss';

import type { IFooterCta } from './types';

const FooterCta = ({ buttons, headline = '', ...props }: IFooterCta) => (
  <aside
    className={
      generateClassName([
        s.footerCta,
        'defaultPaddingTop',
        'defaultPaddingBottom'
      ])}
      {...props}
    >
    <div className="grid">
      <div className={s.contentWrapper}>
        {headline && <h2 className={generateClassName([s.headline, 'h3'])} dangerouslySetInnerHTML={{ __html: headline }} />}
        <Buttons buttons={buttons} buttonColor="light" variants={['primary', 'ghost']} />
      </div>
    </div>
  </aside>
);

export default FooterCta;
